import { Enums } from '../common/enums'

import { IOpData } from '../util/interfaces'

import { OpDataType } from '../core/op-data-type'


export class OpActorData implements IOpData {

    // Properties

    public idActorData: number
    public idActor: number
    public idDataType: number
    public indexNbr: number
    public value: any

    // Properties end


    // NavigationProperties

    public dataType: OpDataType

    // NavigationProperties end


    constructor(opObj: any) {
        this.fromJSON(opObj)
    }


    // IOpChangeState implementation

    public opState: Enums.OpChangeState

    // IOpChangeState implementation end


    // IOpData implementation

    public get idData() { return this.idActorData }
    public set idData(idData: number) { this.idActorData = idData }

    public get indexNBR() { return this.indexNbr }
    public set indexNBR(indexNBR: number) { this.indexNbr = indexNBR }

    // IOpData implementation end

    public toString() {
        return "ActorData [" + this.idData + "]"
    }

    public fromJSON(opObj: any, compress: boolean = false) {
        if (opObj) {
            this.idActorData = opObj.IdActorData
            this.idActor = opObj.IdActor
            this.idDataType = opObj.IdDataType
            this.indexNbr = opObj.IndexNbr
            this.value = opObj.Value
            this.opState = opObj.OpState

            if (opObj._DataType != null) {
                this.dataType = new OpDataType(opObj._DataType)
            }
        } else {
            this.idActorData = 0;
            this.opState = Enums.OpChangeState.New
        }
    }

    public toJSON(compress: boolean = false): any {
        return {
            ID_ACTOR_DATA: this.idActorData,
            ID_ACTOR: this.idActor,
            ID_DATA_TYPE: this.idDataType,
            INDEX_NBR: this.indexNbr,
            VALUE: this.value
        }
    }

    public static fromIOpData(data: IOpData): OpActorData {
        const newData: OpActorData = new OpActorData(null)

        newData.idActorData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }
}